import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react';
import { usePrivateAccessModalStore } from '@/security/components/PrivateAccessModal/PrivateAccessModalStore';
import { AccessGroup } from '@/security/entities/AccessGroup';
import AssigneeSelect from './AssigneeSelect/AssigneeSelect';
function PrivateAccessAssigneeSelect(props) {
    const { value, onChange, disabled } = props;
    const { defaultAssigneeOptions, loadAssignees: baseLoadAssignees, addedEmails, addedGroupIds, } = usePrivateAccessModalStore();
    const isAllowed = useCallback((assignee) => {
        if (assignee instanceof AccessGroup) {
            return !addedGroupIds.has(assignee.id);
        }
        return !addedEmails.has(assignee.email.toLowerCase().trim());
    }, [addedEmails, addedGroupIds]);
    const defaultOptions = useMemo(() => defaultAssigneeOptions.filter(isAllowed), [defaultAssigneeOptions, isAllowed]);
    const loadAssignees = useCallback(async (searchQuery) => {
        const assignees = await baseLoadAssignees(searchQuery);
        return assignees.filter(isAllowed);
    }, [baseLoadAssignees, isAllowed]);
    const isEmailAllowed = useCallback((email) => !addedEmails.has(email), [addedEmails]);
    const formatCreateLabel = useCallback((inputValue) => `Add "${inputValue}"`, []);
    return (_jsx(AssigneeSelect, { value: value, onChange: onChange, disabled: disabled, isMulti: true, isEmailAllowed: isEmailAllowed, defaultOptions: defaultOptions, loadAssignees: loadAssignees, formatCreateLabel: formatCreateLabel }));
}
export default observer(PrivateAccessAssigneeSelect);
